"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncChartSettings = exports.useOptionsFromFormData = void 0;
const react_1 = require("react");
const useOptionsFromFormData = (options, formData) => {
    return (0, react_1.useMemo)(() => {
        const formDataMap = new Map(formData.map((item) => [item.id, item]));
        return options.map((id) => {
            var _a;
            const existing = formDataMap.get(id);
            return {
                id,
                value: id,
                title: id,
                chartType: (_a = existing === null || existing === void 0 ? void 0 : existing.chartType) !== null && _a !== void 0 ? _a : 'column'
            };
        });
    }, [options, formData]);
};
exports.useOptionsFromFormData = useOptionsFromFormData;
const useSyncChartSettings = (formData, mergedOptions, setLocalData, onChange) => {
    (0, react_1.useEffect)(() => {
        const isDifferent = () => {
            if (!Array.isArray(formData) || !Array.isArray(mergedOptions))
                return false;
            if (formData.length !== mergedOptions.length)
                return true;
            const sortById = (arr) => [...arr].sort((a, b) => a.id.localeCompare(b.id));
            const a = sortById(formData);
            const b = sortById(mergedOptions);
            for (let i = 0; i < a.length; i++) {
                if (a[i].id !== b[i].id) {
                    return true;
                }
            }
            return false;
        };
        if (isDifferent()) {
            const minimalData = mergedOptions.map(({ id, chartType }) => ({ id, chartType }));
            setLocalData(minimalData);
            onChange(minimalData);
        }
    }, [mergedOptions, formData, onChange]);
};
exports.useSyncChartSettings = useSyncChartSettings;
//# sourceMappingURL=hooks.js.map